import { Box, Grid, Typography } from "@mui/material";
import trueidLogo from "../../../assests/TrueID-Logo.png";

const ThankyouMessage = () => {
  return (
    <Grid sx={{ justifyContent: "center", textAlign: "center" }}>
      <Box component="img" src={trueidLogo} alt="TrueID Logo" width={"40%"} />
      <Typography variant="h6" sx={{ fontWeight: "bold", mt: 2, mb: 1 }}>
        Thank you! We've received your request
      </Typography>
      <Typography variant="body1" sx={{ mb: 2 }}>
        Our team will contact you shortly
      </Typography>
    </Grid>
  );
};

export default ThankyouMessage;
